import actions from "./action";

const initialState = {
  selectedMembers: [],
};

export default function areas(state = initialState, action) {
  switch (action.type) {
    case actions.ADD_MULTIPLE_AUTH_SENDERS: {
      const selectedMembers = Array.isArray(state.selectedMembers)
        ? state.selectedMembers
        : [];

      return {
        ...state,
        authorizedSendersMembers: [
          ...selectedMembers.filter((memberId) => memberId === 0),
        ],
      };
    }
    case actions.SELECT_AUTH_SENDER_MEMBER: {
      const selectedMembers = Array.isArray(state.selectedMembers)
        ? state.selectedMembers
        : [];

      return {
        ...state,
        selectedMembers: [...selectedMembers, action.payload],
      };
    }
    case actions.DESELECT_SELECTED_POPUP_ENTITY: {
      // Added a check to see if the payload is an array
      const selectedMembers = Array.isArray(state.selectedMembers)
        ? state.selectedMembers
        : [];

      if (!selectedMembers.includes(action.payload)) {
        return {
          ...state,
          selectedMembers,
        };
      }

      return {
        ...state,
        selectedMembers: selectedMembers.filter(
          (member) => Number(member) !== Number(action.payload)
        ),
      };
    }
    case actions.DESELECT_ALL_SELECTED_POPUP_ENTITY: {
      return {
        ...state,
        selectedMembers: [],
      };
    }
    default:
      return state;
  }
}
